/**
 * Dashboard > Dashboard - 월별 Area 이상 검출 건수 조회 component
 */
import API from '@/views/Fdc/Apis/'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

export default {
  name: 'MonthlyFaultStatsByArea',
  props: {
    parentInfo: {
      type: Object,
      default () {
        return null
      }
    }
  },
  watch: {
    parentInfo (value) {
      var nMonth = value.date
      if (nMonth) {
        this.search(this.parentInfo)
      }
    }
  },
  methods: {
    /**
     * Chart Data 조회 (월별 Area 이상 검출 건수)
     */
    async search (condition) {
      const payload = {
        fab: 'BRIQUE', // TODO :: 처리 필요
        nMonth: condition.date
      }
      this.monthTitle = condition.date

      this.fab = payload.fab
      this.date = payload.nMonth

      await API.Monitor.getMonthlyFaultStatsByArea(payload, this.callbackMonthlyFaultStatsByArea, [this.$refs.monthlyFaultStatsByAreaChart])
    },
    /**
     * Chart Data 조회 callback
     * @param {*} response Chart Data 조회 결과
     */
    callbackMonthlyFaultStatsByArea (response) {
      if (response && response.status === 200) {
        this.drawChart(response.data)
      }
    },
    /**
     * Draw Chart
     * @param {*} traces plotly chart data
     */
    drawChart (traces) {
      traces.forEach(trace => {
        trace.name = ''
        trace.type = 'pie'
        trace.hole = 0.5
        trace.textposition = 'inside'
        trace.texttemplate = '%{label}<br>%{value:.2%}'
        trace.hovertemplate = '%{label}<br>%{text.sumCount:,}'
      })
      const layout = {
        hovermode: 'x unified'
      }
      const config = {
        responsive: true,
        displayModeBar: false
      }
      // const chartOption = {
      //   legend: {
      //     position: 'right'
      //   }
      // }

      BriqueChart.newPlot('monthlyFaultStatsByAreaChart', traces, layout, config).then(() => {
        let chart = document.querySelector('#monthlyFaultStatsByAreaChart')
        chart.on('plotly_click', event => this.plotlyClick(event.points[0].label))

        if (traces.length > 0) {
          this.plotlyClick(traces[0].labels[0])
        }
      })
    },
    /**
     * Chart Click Method
     * @param {*} area 클릭된 point의 Area data
     */
    plotlyClick (area) {
      this.$emit('data-selected', {
        fab: this.fab,
        area: area,
        date: this.date
      })
    }
  },
  data () {
    return {
      rowData: [], // chart data
      sum: null, // 전체 이상검출 건수 합
      selectedIndex: null, // 선택된 chart point index
      monthTitle: null // 상위 component에서 선택된 월 정보
    }
  }
}
